import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ServiceDeskPortalSettingsRelayQuery, {
	type srcviewServiceDeskClassicPortalSettingsQuery,
} from '@atlassian/jira-relay/src/__generated__/srcviewServiceDeskClassicPortalSettingsQuery.graphql';

export const serviceDeskPortalClassicSettingsResource =
	createRelayResource<srcviewServiceDeskClassicPortalSettingsQuery>({
		type: `${RELAY_RESOURCE_TYPE}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
		getQuery: (_, { tenantContext: { cloudId } }) => ({
			parameters: ServiceDeskPortalSettingsRelayQuery,
			variables: { cloudId, input: { onlyMyAgents: true, onlyFavouriteAgents: false } },
			options: { fetchPolicy: 'store-and-network' },
		}),
		isCritical: true,
	});
